import { PaginatedResult, PaginationRequest, SystemEvents } from "@ews/react-data";
import { IonCol } from "@ionic/react";
import { useCallback, useEffect, useState } from "react";
import { Locale } from "../../../../setup/locale";
import FilterList, { isFilterActive } from "../../../FilterList/FilterList";
import List from "../../../List/List";
import { defaultPageRange } from "../../../List/Pagination/pagerange";
import { HeaderOption } from "../../../List/types";
import { useNamedRoutes } from "../../../NamedRoutes";
import { useFetchSystemEvents } from "../../../ReactData/system";
import TypeaheadString from "../../../TypeAhead/TypeAheadString";
import { Filter } from "../types/reportTypes";
import { EventFilterKeys, TypeDefinitionSubmissionDocumentsProps } from "./types";

const standardFilter: Filter<EventFilterKeys> = {
    sortCriteria: "runningNumber",
    sortOrder: "ASC",
    pageSize: defaultPageRange
};

type PersistentFilter = PaginationRequest;
const ignoreKeys: (keyof PersistentFilter)[] = ["pageSize", "isFilterOpen", "page", "pageSize", "sortCriteria", "sortOrder"];

const header: HeaderOption<Locale, SystemEvents>[] = [
    {
        title: '[SID_GROUP_DEV]', // okay? oder COM_FACPMANAGEMENT_GRUPPE
        key: 'zone',
        both: true
    },
    {
        title: 'TD_ELEM2',
        key: 'element',
        breakpoint: 1200,
        up: true
    },
    {
        title: 'TD_TEXT_1',
        key: 'text1',
        breakpoint: 1200,
        up: true
    },
    {
        title: 'TD_TEXT_2',
        key: 'text2',
        breakpoint: 1200,
        up: true
    },
    /*    {
           title: 'COM_PAYPLANS_GROUP_EDIT_PARENT',
           key: 'parentGroup',
           breakpoint: 1200,
           up: true
       },
       {
           title: 'COM_BANNERS_FIELD_TYPE_LABEL',
           key: 'type',
           breakpoint: 1200,
           up: true
       }, */

];


const TypeDefinitionSubmissionDocuments: React.FC<TypeDefinitionSubmissionDocumentsProps> = ({
    system,
    filter,
    onIsOpen,
    onFilterActive
}) =>
{

    const [result, setResult] = useState<PaginatedResult<SystemEvents>>({
        currentPage: 0,
        pageSize: standardFilter.pageSize || defaultPageRange,
        totalCountOfEntries: 0,
        totalCountOfPages: 0,
        results: [],
    }
    );

    const [currentState, setState] = useState<PaginationRequest>({ ...standardFilter });
    const [clearFilterInputs] = useState(false);

    const { params } = useNamedRoutes();
    const { id: systemId } = params();

    const fetchSystemEvents = useFetchSystemEvents();

    async function handleFilterResponse(filterCriteria: PaginationRequest)
    {
        const response = await fetchSystemEvents(systemId!, filterCriteria);

        setResult(response);
    }

    useEffect(() =>
    {
        handleFilterResponse(currentState);
    }, [currentState]);


    const onIsFilterOpen = useCallback((state: boolean) => { onIsOpen && onIsOpen(state, "main"); }, [onIsOpen]);
    const onIsDetailFilterOpen = useCallback((isDetailOpen: boolean) => onIsOpen && onIsOpen(isDetailOpen, "detail"), [onIsOpen]);
    const onResetFilter = useCallback(() => setState(() => standardFilter), [setState]);

    const isFilterChanged = isFilterActive<PersistentFilter>(currentState, standardFilter, ignoreKeys);

    useEffect(() =>
    {
        if (filter?.isFilterActive !== isFilterChanged) {
            onFilterActive && onFilterActive(isFilterChanged);
        }
    }, [isFilterChanged, filter, onFilterActive]);


    /*   useEffect(() =>
      {
          //if (system.id) getFilteredData(system.id, filterEvents);
      }, [filterEvents, system]); */


    return <>
        <FilterList
            isOpen={filter?.isFilterOpen || false}
            isDetailsOpen={filter?.isDetailOpen || false}
            onIsOpen={onIsFilterOpen}
            onDetailOpen={onIsDetailFilterOpen}
            onReset={onResetFilter}
            noPrint
        //onDetailOpen={(state) => setHideDetailsFilter(state)}
        >
            <IonCol>
                <TypeaheadString
                    id="group"
                    reset={clearFilterInputs}
                    onFilter={async (value: string) =>
                    {
                        //setState({ ...currentState, systemId: (a: string, b: string): boolean => stringFilter(a, value) });
                        //const list = await getList(data, 'systemId');
                        return [];
                    }}

                    text={"[SID_GROUP_DEV]"} //'[SID_GROUP_DEV]', // okay? oder COM_FACPMANAGEMENT_GRUPPE
                />
                <TypeaheadString
                    id="element"
                    reset={clearFilterInputs}
                    onFilter={async (value: string) =>
                    {
                        //setState({ ...currentState, systemId: (a: string, b: string): boolean => stringFilter(a, value) });
                        //const list = await getList(data, 'systemId');
                        return [];
                    }}

                    text={"TD_ELEM2"}
                />
            </IonCol>
            <IonCol></IonCol>
            <IonCol></IonCol>
        </FilterList >


        <List
            rows={result.results}
            sort={currentState.sortCriteria ? {
                key: currentState.sortCriteria,
                direction: currentState.sortOrder || "ASC"
            } : undefined}

            onSort={(sortCriteria, sortOrder) => setState({ ...currentState, sortCriteria, sortOrder })}
            onPageChange={(page) => setState({ ...currentState, page })}
            pageSize={result.pageSize}
            currentPage={result.currentPage}
            numberOfPages={result.totalCountOfPages}
            noLink
            //link={{ url: "system:events", paramsKey: "id" }}

            headers={header}
        />
    </>;
};

export default TypeDefinitionSubmissionDocuments;
